import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import { IonicModule } from "@ionic/angular";

import { OtpPageRoutingModule } from "./otp-routing.module";

import { OtpPage } from "./otp.page";
import { NgCircleProgressModule } from "ng-circle-progress";
import { ComponentsModule } from 'src/app/components/components.module';
import { DesignSystemModule } from "src/theme/design-system/design-system.module";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    OtpPageRoutingModule,
    ReactiveFormsModule,
    NgCircleProgressModule,
    NgCircleProgressModule.forRoot({
      radius: 80,
      space: -10,
      titleFontSize: "14",
      outerStrokeColor: "#000000",
      innerStrokeColor: "#e7e8ea",
      outerStrokeWidth: 10,
      innerStrokeWidth: 10,
      animationDuration: 300,
      showImage: false,
      showSubtitle: false,
      showUnits: false,
    }),
    ComponentsModule,
    DesignSystemModule
  ],
  declarations: [OtpPage],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class OtpPageModule { }
